import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { EditIcon, CloseIcon } from './../../../themes/icons';
import { Loading } from './../../../components/includes/loading';
import { Section, Content, Main, Buttons } from './../../../components/includes/container';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Table, Thead, Tbody, Row, Cell, Tresponsive, Ttolbar } from './../../../components/includes/ui/table';
import { Btn, Link, Label } from './../../../components/includes/ui';
import { FormatDate } from './../../../utilities/date';
import { FormatCurrency } from './../../../utilities/currency';
import { isUndefined, isSorting, isStatus, buildSalesRouting } from './../../../utilities/utils';
import { ProductService } from './../../../services';
import Confirm from './../../shared/confirm';
import Find from './../find';

const rows = [
  { id: 'name', sort: false, numeric: false, disablePadding: false, label: 'Nombre' },
  { id: 'link', sort: false, numeric: false, disablePadding: false, label: 'Link' },
  { id: 'status', sort: false, numeric: false, disablePadding: false, label: 'Estado' },
  { id: 'price', sort: false, numeric: false, disablePadding: false, label: 'Precio' },
  { id: 'created_at', sort: false, numeric: false, disablePadding: false, label: 'Creado' },
  { id: 'updated_at', sort: false, numeric: false, disablePadding: false, label: 'Editado' },
  { id: 'actions', sort: false, numeric: true, disablePadding: false, label: 'Acciones', width:120, minWidth: 120 }
];

class Products extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      page: 0,
      order: 'asc',
      orderBy: 'name',
      entities: null,
      formAddShow: false,
      formDeleteShow: false,
      formDeleteMessage: null
    };
  }

  componentDidMount(){

    // @Pagination
    let page = this.props.match.params.page;

    if(!isUndefined(page)){

      if(!isNaN(page) && page >= 0){

        this._Find(page);

      }else{

        this.props.history.push('/products');

      }

    }else{

      this._Find(this.state.page);

    }

  }

  /*
  ** @Service
  ** @Description: FindAll
  */

  _Find = (page) => {

    ProductService.get(page).then((response) => {

      this.setState({ loading: true, page: !isUndefined(page) ? parseInt(page,10) : 0, entities: response });

    }).catch((error) => {

      //this.props.AlertShow({ open: true, variant: 'error', message: Error.internal });

    });

  }

  /*
  ** @Service
  ** @Description: Update
  */

  _Update = (id) => {

  }

  /*
  ** @Service
  ** @Description: Delete
  */

  _Delete = (id) => {

    ProductService.remove(id).then((response) => {

      // @State
      this.setState({ formDeleteShow: false });

      // @Service find all by page
      this._Find(this.props.match.params.page);

      // @Dispatch alert success
      this.props.AlertShow({ open: true, variant: 'success', message: `Exito, el producto fue eliminado.` });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: Error.internal });

    });

  }

  /*
  ** @Click
  ** @Description: Show new products
  */

  handleShowAdd = () => {
    this.setState({ formAddShow: true });
  }

  /*
  ** @Click
  ** @Description: Cancel create new product
  */

  handleCancelAdd = () => {
    this.setState({ formAddShow: false });
  }

  /*
  ** @Click
  ** @Description: Success create new product
  */

  handleSuccessAdd = (product) => {

    // @State
    this.setState({ formAddShow: false });

    // @Redirect
    this.props.history.push(`/products/update/${ product._id }`);

  }

  /*
  ** @Click
  ** @Description: Update user
  */

  handleUpdate = (id) => {
    this._Update(id);
  }

  /*
  ** @Event
  ** @Description: Delete user
  */

  handleDelete = (id, name) => {
    this.setState({
      id: id,
      formDeleteShow: true,
      formDeleteMessage: `¿Confirma la eliminación de Producto ${ name }?`
    });
  }

  /*
  ** @Click
  ** @Description: Delete user
  */

  handleConfirmDeleteConfirm = () => {
    this._Delete(this.state.id);
  }

  /*
  ** @Click
  ** @Description: Cancel delete user
  */

  handleConfirmDeleteCancel = () => {
    this.setState({ formDeleteShow: false });
  }

  render() {

    const { loading, order, orderBy, entities } = this.state;

    return (
      <Section>

        <ToolbarPrimary title="Productos"/>
        <BreadcrumbItem to='/products'>Productos</BreadcrumbItem>

        {/*
        { this.state.formAddShow && (
          <Find status={ true } onCancel={ this.handleCancelAdd } onSuccess={ this.handleCeate }/>
        )}
        */}

        <Find
            status={ this.state.formAddShow }
            onCancel={ this.handleCancelAdd }
            onSuccess={ this.handleSuccessAdd }
        />

        <Content>
          <Main>

            <Confirm
               status={ this.state.formDeleteShow }
               message={ this.state.formDeleteMessage }
               cancel={ () => { this.handleConfirmDeleteCancel() } }
               confirm={ () => { this.handleConfirmDeleteConfirm() } }
            />

            <Ttolbar title="Productos">
              <Buttons>
                <Btn color="success" aria-label="add" icon="add" onClick={ this.handleShowAdd }>
                  Crear producto
                </Btn>
                {/*
                <Btn color="success" aria-label="add" icon="add" component={ NavLink } to="/products/create">
                  Crear producto
                </Btn>
                */}
              </Buttons>
            </Ttolbar>

            { loading ? (
              <Tresponsive>
                <Table>

                  <Thead rows={ rows } order={ order } orderBy={ orderBy } onRequestSort={ this.handleRequestSort }/>

                  <Tbody>

                    { entities.products.length > 0 ? (

                      entities.products.sort(isSorting(order, orderBy)).map(entity => {
                        return (
                          <Row key={ entity._id }>
                            <Cell>
                              <span>
                                <Link to={ `/products/update/${ entity._id }` }>
                                  { entity.name }
                                </Link>
                              </span>
                            </Cell>
                            <Cell>
                              <span>
                                <Link to={ buildSalesRouting(entity) } isExrernal>
                                  { entity.slug }
                                </Link>
                              </span>
                            </Cell>
                            <Cell>
                              <Label variant={ entity.status ? "success" : "danger"}>
                                { isStatus(entity.status) }
                              </Label>
                            </Cell>
                            <Cell>
                              <FormatCurrency value={ entity.price }/>
                            </Cell>
                            <Cell>
                              <FormatDate value={ entity.created_at }/>
                            </Cell>
                            <Cell>
                              <FormatDate value={ entity.updated_at }/>
                            </Cell>
                            <Cell numeric>
                              <Btn color="danger" size="xsmall" onClick={ () => { this.handleDelete(entity._id, `${ entity.name }`) } }>
                                <CloseIcon fontSize="small"/>
                              </Btn>
                              <Btn color="primary" size="xsmall" component={ NavLink } to={ `/products/update/${ entity._id }` }>
                                <EditIcon fontSize="small"/>
                              </Btn>
                            </Cell>
                          </Row>
                        );
                      })

                    ) : (

                      <Row key="1">
                        <Cell colSpan={ rows.length }>No se encontraron resultados.</Cell>
                      </Row>

                    )}

                  </Tbody>
                </Table>
              </Tresponsive>
            ) : (
              <Loading variant="primary"/>
            ) }

          </Main>
        </Content>
      </Section>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Products);
